<template>
  <div>
    <vs-navbar>
      <vs-navbar-item id="/" to="/">Orders</vs-navbar-item>
      <vs-navbar-item id="/shipments" to="/shipments">Shipments</vs-navbar-item>
      <vs-navbar-item id="/products" to="/products">Products</vs-navbar-item>
    </vs-navbar>

    <vs-sidebar open v-model="activeRoute">
      <template #logo>
        <div id="logo">Open <b>PO</b></div>
      </template>

      <vs-sidebar-item id="/" to="/">
        <template #icon><i class="bx bx-dollar-circle" /></template>
        Orders
      </vs-sidebar-item>

      <vs-sidebar-item id="/shipments" to="/shipments">
        <template #icon><i class="bx bx-package" /></template>
        Shipments
      </vs-sidebar-item>

      <vs-sidebar-item id="/products" to="/products">
        <template #icon><i class="bx bx-chart" /></template>
        Products
      </vs-sidebar-item>

      <template #footer>
        <vs-sidebar-item>
          <template #icon><i class="bx bx-log-out" /></template>
          <div @click="signOut">Sign Out</div>
        </vs-sidebar-item>
      </template>
    </vs-sidebar>

    <div id="content">
      <router-view />
    </div>
  </div>
</template>

<script>
import supabase from '../supabase';

export default {
  name: 'Home',

  data() {
    return {
      activeRoute: '',
    };
  },

  created() {
    this.activeRoute = this.$router.currentRoute.path;
  },

  methods: {
    async signOut() {
      try {
        await supabase.auth.logout();

        this.$router.push({ path: '/sign-in' });
      } catch (error) {
        alert(JSON.parse(error.message).msg);
      }
    },
  },
};
</script>
